var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"k8s-exchange-front-nodejs-build-blockfin-exchange-activity-prod20250903-1450"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/frontend/_next_blockfin_website_1756882300663";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: SENTRY_DSN || 'https://335dbee9c845ce9584e53107939463a6@o4504796493905920.ingest.us.sentry.io/4509078082355200',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0.1,
  ignoreErrors: ['network error', 'ChunkLoadError', 'Non-Error promise rejection'],
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  environment: process.env.NEXT_PUBLIC_MODE || 'pre',
  enabled: process.env.NEXT_PUBLIC_MODE === 'prod',
  integrations: [new Sentry.Replay()],
  enabled: process.env.NEXT_PUBLIC_MODE === 'prod',
});
